export const SENSITIVE = 'sensitive';
export const HIGHLY_SENSITIVE = 'highly_sensitive';